




































import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action } from 'vuex-class';
import { getUserFullName, getDate } from '@/helpers/functions';
import { Prop } from 'vue-property-decorator';
import { client } from '@/store';
@Component({
  methods: {
    getUserFullName,
    getDate,
  },
})
export default class History extends Vue {
  @State('currentUser', { namespace: 'user' }) user: boolean;
  @Prop(Object)
  readonly historySettings: object;
  currentHistory = null;
  currentClass = null;
  // @ts-ignore
  async setHistory({ id, className }) {
    const { data } = await client.get(`history`, {
      params: {
        className,
        id,
      },
    });
    this.currentHistory = data;
  }
  async mounted() {
    // @ts-ignore
    await this.setHistory(this.historySettings);
  }
}
